import moment from 'moment';
import S_base from '@/__vue2stone/service/wasaapi/v1/__base';
import base from '@/service/api/v1/__base';
import store from '@/store';
import i18n from '@/i18n';
import H_common from "@/helpers/common";

export default {
  async show(requestId, params) {
    //取得request內容
    const res = await base.show({
      modelName: 'audit_request',
      modelId: requestId,
      params: params,
    });
    return res;
  },
  // async show(requestId, params) {
  //   //取得request內容
  //   const currentFactory = store.state.app.factory;
  //   const _params = {
  //     factory: currentFactory.id,
  //     ...params,
  //   };
  //   const res = await S_base.show({
  //     modelName: 'audit_request',
  //     modelId: requestId,
  //     params: _params,
  //   });
  //   return res;
  // },
  async getFactoryIndex(factoryId, params) {
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await S_base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'audit_request',
      params: _params,
      pagination: true,
    });
    return res;
  },
  async indexAll(factoryId, params) {
    //board calendar
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await S_base.index({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'audit_request',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async indexAllV2(params) {
    const currentFactoryId = store.state.app.factory.id;
    const _params = {
      factory: currentFactoryId,
      ...params,
    };
    const res = await S_base.index({
      parentName: 'factory',
      parentId: currentFactoryId,
      modelName: 'audit_request/index/board',
      params: _params,
      pagination: false,
    });
    return res;
  },
  async createRequest(data, auditId) {
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await S_base.create({
      parentName: 'audit',
      parentId: auditId,
      modelName: 'audit_request',
      data: _data,
    });
    return res;
  },
  getRequestData(request) {
    //送出request時的data
    return {
      name: request.name,
      record_at: request.recordAt,
      auditee_notify: request.auditeeNotify ? 1 : 0,
      // auditor: request.auditor,
      auditors: request.auditors,
      // auditee: request.auditee,
      auditees: request.auditees,
      factory: request.factory,
    };
  },
  getAssignmentContent(request) {
    //取得稽核作業內容
    return {
      title: request.name,
      date: this.$_getDateFormat(request.record_at),
      auditees: request.auditees,
      auditors: request.auditors,
      audit: request.audit_id,
    };
  },
  $_getDateFormat(date) {
    if (!date) return '';
    return moment(date)
      .format('YYYY-MM-DD');
  },
  $_getTimeFormat(date) {
    if (!date) return '';
    return moment(date)
      .format('YYYY-MM-DD HH:mm:ss');
  },
  getAssignmentQues(chapters) {
    //取得稽核作業的答題題目格式
    const allQues = [];
    chapters.forEach((chapter) => {
      chapter.sectionList.forEach((section) => {
        section.questionList.forEach((question) => {
          allQues.push({
            question: {
              type: question.type,
              id: question.id,
              title: question.title,
              remark: question.remark,
              chapter: chapter.title,
              section: section.title,
              versionId: question.versionId,
            },
            answer: {
              score: null,
              images: [],
              remark: '',
            },
          });
        });
      });
    });
    return allQues;
  },
  getChaptersWithAnswers(chapters, answers) {
    if (chapters.length === 0 || answers.length === 0) return [];
    const _answers = JSON.parse(JSON.stringify(answers));
    let _chapters = JSON.parse(JSON.stringify(chapters));
    _chapters.forEach((chapter) => {
      chapter.sectionList.forEach((section) => {
        section.questionList = section.questionList.map((question) => {
          let score = null
          let remark = null
          let images = []
          let actVersionAlls = [];
          let articleVersions = [];
          let effects = [];
          let factoryEffects = [];
          let lawList = [];
          let riskSignal = [];
          let questionImages, questionAttaches, questionTempAttaches, questionTempImages = [];
          const tarQues = _answers.find(
            (answer) => answer.question.id === question.id,
          )
          if (tarQues) {
            const answer = tarQues.answer
            score = answer.score
            remark = answer.remark
            images = answer.images
            const ques = tarQues.question;
            const {actVersionAlls: _actVersionAlls, articleVersions: _articleVersions} = H_common.setSubmitActAndArticle(ques.lawList);
            actVersionAlls = _actVersionAlls;
            articleVersions = _articleVersions;
            if (ques.riskSignal && ques.riskSignal.length) {
              effects = ques.riskSignal[0];
              factoryEffects = ques.riskSignal[1];
              riskSignal = ques.riskSignal;
            }
            lawList = ques.lawList;
            questionImages = ques.images;
            questionAttaches = ques.attaches;
            questionTempImages = ques.tempImages;
            questionTempAttaches = ques.tempAttaches;
          }
          const alertText =
            question.riskSignal && question.riskSignal.length > 0
              ? question.riskSignal.map((effect) => effect.name).join('、')
              : '';
          return {
            id: question.id,
            score,
            focus: question.focus,
            title: question.title,
            subtitle: question.subtitle,
            remark,
            images,
            acts: question.act_version_alls,
            riskSignal,
            articles: question.article_versions,
            questionRemark: question.remark,
            versionId: question.versionId,
            templateId: question.templateId,
            templateVersionId: question.templateVersionId,
            payload: question.payload,
            questionImages,
            questionAttaches,
            questionTempImages,
            questionTempAttaches,
            alertText:
              question.score !== 25 && alertText
                ? `${i18n.t('風險')}：${alertText}`
                : '',
            actVersionAlls,
            articleVersions,
            effects,
            factoryEffects,
            lawList,
            guidelineList: tarQues ? tarQues.question.guidelineList : [],
          };
        });
      });
    });
    return _chapters;
  },
  getCustomedIndex(list) {
    let _list = JSON.parse(JSON.stringify(list));
    _list.forEach((chapter) => {
      const cIndex = _list.indexOf(chapter) + 1;
      chapter.chapterCustomedIndex = `${cIndex}` + '.';
      chapter.sectionList.forEach((section) => {
        const sIndex = chapter.sectionList.indexOf(section) + 1;
        section.sectionCustomedIndex = `${cIndex}` + '-' + `${sIndex}` + '.';
        section.questionList.forEach((question) => {
          const qIndex = section.questionList.indexOf(question) + 1;
          question.questionCustomedIndex =
            `${cIndex}` + '-' + `${sIndex}` + '-' + `${qIndex}` + '.';
        });
      });
    });
    return _list;
  },
  getAllQuesResult(chapters) {
    //從章節中取得所有題目
    const allQues = [];
    chapters.forEach((chapter) => {
      chapter.sectionList.forEach((section) => {
        section.questionList.forEach((question) => {
          allQues.push(question);
        });
      });
    });
    return allQues;
  },
  getChapterRiskSort(riskSort, questions) {
    //依照risk排序
    const _riskSort = riskSort.map((sort) => {
      sort.questionList = questions.filter(
        (question) => question.score === sort.score,
      );
      return sort;
    });
    return _riskSort;
  },
  getRiskNum(risk, questions) {
    const _questions = questions.filter(
      (question) => parseInt(question.score) === risk,
    );
    return _questions.length;
  },
  async showDraft(draftId, params) {
    //取得request內容
    const currentFactory = store.state.app.factory;
    const _params = {
      factory: currentFactory.id,
      ...params,
    };
    const res = await S_base.show({
      modelName: 'audit_record_draft',
      modelId: draftId,
      params: _params,
    });
    return res;
  },
  async createDraft(factoryId, data) {
    //create record draft
    const _data = {
      factory: store.state.app.factory.id,
      ...data,
    };
    const res = await S_base.create({
      parentName: 'factory',
      parentId: factoryId,
      modelName: 'audit_record_draft',
      data: _data,
    });
    return res;
  },
};
